const branchRuleActions = {
    types: {
        BRANCH_RULES_SET_ACTION_IN_PROGRESS: 'EVALUATING_SET_ACTION_IN_PROGRESS',
        BRANCH_RULES_SET_HAS_EVALUATED: 'EVALUATING_SET_HAS_EVALUATED',
    },

    progressActions: {
        EVALUATE_BRANCH_RULE: 'EVALUATE_BRANCH_RULE',
    },

    setActionInProgress(actionInProgress) {
        return { type: this.types.BRANCH_RULES_SET_ACTION_IN_PROGRESS, actionInProgress };
    },

    setHasEvaluated(hasEvaluated) {
        return { type: this.types.BRANCH_RULES_SET_HAS_EVALUATED, hasEvaluated };
    },
};

export default branchRuleActions;
